export * from './full-staff-layout.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/containers/full-staff-layout/index.ts